import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";
import AdNav from "../components/adNav";
import Time from "../components/time";

const AddNewFile = () => {
  const [heading, setHeading] = useState([]);
  const [subHeading, setSubHeading] = useState([]);
  const [innerHeading, setInnerHeading] = useState([]);
  const [formData, setFormData] = useState({
    heading: "",
    subHeading: "",
    innerSub: "",
    sort: "",
    fileName: "",
    fileDesc: "",
    file: null,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchHeading = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/fileList_heading");
        setHeading(response.data.heading);
      } catch (error) {
        console.error("Error fetching heading:", error);
      }
    };
    fetchHeading();
  }, []);

  useEffect(() => {
    const fetchSubHeading = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/fileList_subHeading");
        setSubHeading(response.data.subheading);
      } catch (error) {
        console.error("Error fetching subheading:", error);
      }
    };
    fetchSubHeading();
  }, []);

  useEffect(() => {
    const fetchInnerHeading = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/fileList_innerSubHeading");
        setInnerHeading(response.data.innersub);
      } catch (error) {
        console.error("Error fetching inner heading:", error);
      }
    };
    fetchInnerHeading();
  }, []);

  const handleChange = (e) => {
  const { name, value, files } = e.target;

  if (name === "file") {
    setFormData((prev) => ({ ...prev, file: files[0] }));
  } else {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }
};

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.heading.trim()) {
    Swal.fire({
      icon: 'warning',
      title: 'Empty Field',
      text: 'Please Select your Heading!',
    });
    return;
  }

  if (!formData.subHeading.trim()) {
    Swal.fire({
      icon: 'warning',
      title: 'Empty Field',
      text: 'Please Select your Sub Heading!',
    });
    return;
  }

  if (!formData.innerSub.trim()) {
    Swal.fire({
      icon: 'warning',
      title: 'Empty Field',
      text: 'Please Select your Second Sub Heading!',
    });
    return;
  }

  if (!formData.sort.trim()) {
    Swal.fire({
      icon: 'warning',
      title: 'Empty Field',
      text: 'Please enter your Sort!',
    });
    return;
  }

  if (isNaN(formData.sort.trim())) {
    Swal.fire({
      icon: 'error',
      title: 'Invalid Input',
      text: 'Sort must be a numeric value!',
    });
    return;
  }

  if (!formData.fileName.trim()) {
    Swal.fire({
      icon: 'warning',
      title: 'Empty Field',
      text: 'Please enter your file name!',
    });
    return;
  }

  if (!formData.file) {
    Swal.fire("Warning", "Please upload a file", "warning");
    console.warn("⚠️ No file selected");
    return;
  }

  // ✅ File type validation
  const allowedTypes = [
    "application/pdf", // PDF
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
    "application/msword", // older DOC
    "application/vnd.ms-excel", // XLS
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
    "text/csv", // CSV
  ];

  if (!allowedTypes.includes(formData.file.type)) {
    Swal.fire({
      icon: "error",
      title: "Invalid File",
      text: "Only PDF, DOCX, Excel, and CSV files are allowed!",
    });
    return;
  }

  const fileData = new FormData();
  fileData.append("heading", formData.heading);
  fileData.append("subHeading", formData.subHeading);
  fileData.append("innerSub", formData.innerSub);
  fileData.append("sort", formData.sort);
  fileData.append("fileName", formData.fileName);
  fileData.append("fileDesc", formData.fileDesc);
  fileData.append("file", formData.file);

  try {
    Swal.fire({
      title: "Submitting...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post("https://rfs2.infraconsoft.net.in/api/fileList_insert", fileData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    Swal.fire("Success", "File uploaded successfully", "success");
    navigate("/admin/file_listing");
  } catch (error) {
    Swal.fire("Error", "Upload failed", "error");
  }
};

  return (
    <div id="admin-container">
      <AdNav />
      <div className="content-right">
        <section>
          
                     <div className="back-div">
            <h2 className="add-txt">Add New File</h2>
            <Link to={`/admin/file_listing`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
            </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Heading :</label>
                <select name="heading" value={formData.heading} onChange={handleChange}>
                  <option value="">- Select -</option>
                  {heading.map((item) => (
                    <option key={item.fld_heading} value={item.fld_heading}>
                      {item.fld_heading}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Sub Heading :</label>
                <select name="subHeading" value={formData.subHeading} onChange={handleChange}>
                  <option value="">- Select -</option>
                  {subHeading.map((item) => (
                    <option key={item.fld_subheading} value={item.fld_subheading}>
                      {item.fld_subheading}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Inner Sub Heading :</label>
                <select name="innerSub" value={formData.innerSub} onChange={handleChange}>
                  <option value="">- Select -</option>
                  {innerHeading.map((item) => (
                    <option key={item.fld_addsubHeading} value={item.fld_addsubHeading}>
                      {item.fld_addsubHeading}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Sort Order :</label>
                <input type="text" name="sort" value={formData.sort} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>File Name :</label>
                <input type="text" name="fileName" value={formData.fileName} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label>File Description :</label>
                <input type="text" name="fileDesc" value={formData.fileDesc} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>File :</label>
                <input type="file" name="file" onChange={handleChange} />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden" />
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddNewFile;
